module.exports = __webpack_public_path__ + "static/img/products application_pu3.b4e68986.jpg";